import { get, isFunction } from 'lodash';
import { warn } from '../utils/logger';

export function* openChatWidgetSaga(widgetService) {
    const acceptInvite = get(widgetService, 'inviteAPI.inviteButton.acceptInvite');

    // If the chat service isn't ready, exit early
    if (!isFunction(acceptInvite)) {
        warn('Unable to accept chat invite');
        return false;
    }

    acceptInvite();
    return true;
}
